// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#room-schedule-list .box-header .title[data-v-dd142470]{font-size:22px;font-weight:700}#room-schedule-list .tab-title[data-v-dd142470]{max-height:24px}#room-schedule-list .notification-btn[data-v-dd142470],#room-schedule-list .setting-btn[data-v-dd142470]{width:100px;min-width:100px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
